<template>
  <div v-if="visible" class="fullscreen-editor">
    <div ref="editorContainer" class="editor-container"></div>
  </div>
</template>

<script>
import * as monaco from "monaco-editor";

export default {
  props: {
    value: String,
    language: {
      type: String,
      default: "html",
    },
  },
  data() {
    return {
      visible: false,
      editor: null,
      internalValue: "",
    };
  },
  created() {
    this.open();
  },
  methods: {
    open() {
      this.visible = true;
      this.internalValue = this.value;

      this.$nextTick(() => {
        this.editor = monaco.editor.create(this.$refs.editorContainer, {
          value: this.internalValue,
          language: this.language,
          //language: "json",
          automaticLayout: true,
          theme: "vs-dark",
        });
      });
    },
    save() {
      this.$emit("input", this.editor.getValue());
      this.visible = false;
      this.editor.dispose();
    },
    cancel() {
      this.visible = false;
      if (this.editor) this.editor.dispose();
    },
  },
};
</script>

<style scoped>
.fullscreen-editor {
  position: fixed;
  top: 48px;
  left: 0;
  width: 100%;
  height: calc(100% - 0px);
  background: #1e1e1e;
  z-index: 1000;
  display: flex;
  flex-direction: column;
}

.editor-container {
  flex: 1;
}
</style>
